import { _$post } from "./request/index";
const signOutApi = async (): Promise<boolean> => {
	try {
		await _$post({
			url: "user/logout"
		});
		return true;
	} catch (e) {
		return false;
	}
};

export default signOutApi;
